import { NeoModel, ValueObject } from "@singularsystems/neo-core";

@NeoModel
export default class ImportStatusReportCriteria extends ValueObject  
{
}